import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const EmpresaService = {
    fetchEmpresa: async (token) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ajustes/empresa'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.empresa || {};
        } catch (error) {
            console.error('Error en EmpresaService.fetchEmpresa:', error);
            throw error;
        }
    },
    actualizarEmpresa: async ({ token, empresaData }) => {
        try {
            await axios.put(buildApiUrl('/api/ajustes/empresa'), empresaData, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            console.error('Error en EmpresaService.actualizarEmpresa:', error);
            throw error;
        }
    },
};
